export default __webpack_public_path__ + "static/media/CallOff.7d74a44e.svg";